import EventBus from "../event-bus";

const autoReconnectionFailedHook = new EventBus<{
  path: string;
  connectParams: Record<string, any>;
}>("autoReconnectionFailedHook");

export default autoReconnectionFailedHook;
